module.exports = __webpack_public_path__ + "static/media/2.f9e279e9.png";